import { Box } from "@mui/material";
import { isNil } from "lodash";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setHighlightOverEntrances } from "../OotrReducer";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";

interface TrackLocationPositionProps {
  label?: string;
  img?: string;
}

const 
TrackLocationEntrance = (props: TrackLocationPositionProps) => {
  let [done, setDone] = useState(false);

  let dispatch = useDispatch();
  let entrances = useSelector((state: AppState) => state.ui.ootr.main.entrances);

  return (
    <Box display={"flex"} alignItems={"center"}>
      <Box
        onMouseOver={(e) => {
          e.preventDefault();
           dispatch(setHighlightOverEntrances(Object.values(entrances).filter(x => x.destination === props.label).map(x => x.id)))
          }}
          onMouseLeave={(e) => {
            e.preventDefault();
             dispatch(setHighlightOverEntrances([]))
            }}
        onContextMenu={(e) => {
          e.preventDefault();
          setDone(!done);
        }}
        onClick={() => setDone(!done)}
        draggable
        onDragStart={(e) => {
          e.dataTransfer.setData("text/plain", ("IMPORTANT" + props.label));
        }}
     
        onDragOver={(e) => {
          e.preventDefault();
        }}
        sx={{
          color: done ? "red" : "white",
          textDecoration: done ? "line-through" : "inherit",
          fontWeight: "bold",
          userSelect: "none",
          textShadow: "1px 1px 2px black, 0 0 25px blue, 0 0 5px darkblue",
          width: !isNil(props.img)
            ? "90px"
            : !isNil(props.label)
            ? "100px"
            : "0px",
          fontSize: "12px",
        }}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        {!isNil(props.label) && <Box sx={{fontSize: "18px"}}>{props.label}</Box>}
        {!isNil(props.img) && (
          <Box display={"flex"}><img src={props.img} alt={props.label} height={32} width={32} /></Box>
        )}
      </Box>
    </Box>
  );
};

export default TrackLocationEntrance;
